import { Observable, Subject } from 'rxjs';
import { VehicleModel } from 'app/models/dms/vehicle.model';
import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { FieldUpdateModel } from 'app/models/shared/fieldUpdate.model';

@Component({
    selector: 'app-field-group',
    templateUrl: './field-group.component.html',
    styleUrls: ['./field-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FieldGroupComponent implements OnInit, OnDestroy
{

    @Input() group: FieldGroupModel;
    @Input() editMode: boolean = false;
    @Input() editLink: boolean = false;
    @Input() vehicle: VehicleModel;
    @Input() fieldUpdated: Observable<FieldUpdateModel>;
    @Input() singleColumn: boolean = false;
    private fieldUpdateSubscription: any;

    @Output() fieldClicked = new EventEmitter<object>();
    @Output() fieldChanged = new EventEmitter<object>();
    @Output() fieldRefreshed = new EventEmitter<object>();
    @Output() fieldEditLinkClicked = new EventEmitter<object>();
    @Output() fieldBlurred = new EventEmitter<object>();

    @ViewChild('grid', { static: false, read: ElementRef }) grid?: ElementRef<HTMLElement>;

    fieldUpdatedSubject: Subject<FieldUpdateModel> = new Subject<FieldUpdateModel>();

    constructor()
    {
    }

    ngOnInit()
    {
        if (this.fieldUpdated)
        {
            this.fieldUpdateSubscription = this.fieldUpdated.subscribe(({ id }) => this.fieldChangeEvent(id));
        }
        //set a unique id for the grid
        if (!this.group.id || this.group.id == '')
        {
            this.group.id = 'fg-' + Math.random().toString(36).substring(2, 15);
        }
    }

    ngOnDestroy(): void
    {
        if (this.fieldUpdateSubscription)
        {
            this.fieldUpdateSubscription.unsubscribe();
        }
    }

    public handleFieldClicked(ev: any)
    {
        this.fieldClicked.emit(ev);
    }

    public handleFieldChanged(ev: any)
    {
        // console.log(ev);
        this.fieldChanged.emit(ev);
        if (ev.detail && ev.detail.field && ev.detail.field.hasChildren)
        {
            var payload = new FieldUpdateModel();
            payload.id = ev.detail.field.id;
            this.fieldUpdatedSubject.next(payload);
        }
    }

    public handleFieldRefreshed(ev: any)
    {
        this.fieldRefreshed.emit(ev);
    }

    public handleFieldBlurred(ev: any)
    {
        this.fieldBlurred.emit(ev);
    }

    fieldChangeEvent(id: string)
    {
        // console.log(id);
        var payload = new FieldUpdateModel();
        payload.id = id;
        this.fieldUpdatedSubject.next(payload);
    }

    handleEditLinkClicked(ev: any, group: FieldGroupModel)
    {
        this.fieldEditLinkClicked.emit({ event: ev, group: group });
    }
}
